'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { FlashCard } from '../Card/FlashCard'
import { cardGroupContainerStyles } from './CardGroup.styles'

export type CardGroupOption = {
  description?: string
  icon?: React.ReactNode
  label: string
  value: string
}

export type CardGroupProps = {
  colorScheme?: ColorScheme
  onChange: (value: string) => void
  options: CardGroupOption[]
  value: string
}

export const CardGroup = ({
  colorScheme = 'dark',
  onChange,
  options,
  value,
}: CardGroupProps) => (
  <Box {...cardGroupContainerStyles}>
    {options.map((option) => (
      <FlashCard
        colorScheme={colorScheme}
        description={option.description}
        icon={option.icon}
        isActive={option.value === value}
        key={option.value}
        label={option.label}
        onClick={() => onChange(option.value)}
      />
    ))}
  </Box>
)
